import React, { createContext, useContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface PublicService {
  dbId: number;
  name: string;
  description?: string;
  goal?: string;
  version?: string;
  indicators: PublicIndicator[];
}

export interface PublicIndicator {
  dbId: number;
  name: string;
  stageId: number;
  customizable: boolean;
  unit: string;
  definitionStart: string;
  definitionEnd: string;
  initialForecastStart: string;
  initialForecastEnd: string;
  initialMeasurementStart: string;
  initialMeasurementEnd: string;
  finalForecastStart: string;
  finalForecastEnd: string;
  finalMeasurementStart: string;
  finalMeasurementEnd: string;
  isHuman: boolean;
  definition: string;
  stgName: string;
  version: string;
  impactReceiptText?: string;
}

interface PublicServicesContextValue {
  services: PublicService[];
  loading: boolean;
}

const PublicServicesContext = createContext<PublicServicesContextValue>({
  services: [],
  loading: false,
});

export const usePublicServices = () => useContext(PublicServicesContext);

interface PublicServicesProviderProps {
  children: React.ReactNode;
  services: PublicService[];
  loading?: boolean;
}

export const PublicServicesProvider: React.FC<PublicServicesProviderProps> = ({
  children,
  services,
  loading = false,
}) => {
  return (
    <PublicServicesContext.Provider
      value={{
        services,
        loading,
      }}
    >
      {children}
    </PublicServicesContext.Provider>
  );
};

export default PublicServicesProvider;
